import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { ProductService } from './service/ProductService';

export default function SearchView( {data}) {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        //ProductService.getProductsMini().then(data => setProducts(data));

        // Aqui debemos de leer el backend
/*
        const arr = [
            {
                "NumTel": "5528612080",
                "Nombre": "VICENTE CASTILLO CHAVEZ",
                "NombreBaseTelcel": "DIGSHOP 2Q OCTUBRE 2024"
            },
            {
                "NumTel": "5528612080",
                "Nombre": "VICENTE CASTILLO CHAVEZ",
                "NombreBaseTelcel": "DIGSHOP 2Q NOVIEMBRE 2024"
            },
            {
                "NumTel": "5528612080",
                "Nombre": "VICENTE CASTILLO CHAVEZ",
                "NombreBaseTelcel": "DIGSHOP 2Q DICIEMBRE 2024"
            } ,
            {
                "NumTel": "5528612080",
                "Nombre": "VICENTE CASTILLO CHAVEZ",
                "NombreBaseTelcel": "DIGSHOP 2Q ENERO 2025"
            } ,
            {
                "NumTel": "5528612080",
                "Nombre": "VICENTE CASTILLO CHAVEZ",
                "NombreBaseTelcel": "DIGSHOP 2Q FEBRERO 2024"
            }
        ];
*/
        setProducts(data);

    }, []);

    return (
        <div className="card">
            <DataTable stripedRows value={data} tableStyle={{ minWidth: '50rem' }}>
                <Column field="numtel" header="NumTel"></Column>
                {/* <Column field="nombre" header="Nombre"></Column> */}
                <Column field="nombrebaseactual" header="NombreBaseTelcel"></Column>
                
            </DataTable>
        </div>
    );
}